module.exports = __webpack_public_path__ + "static/img/bg.ff8eac5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/dcqrcode/img/bg.jpg
// module id = 718
// module chunks = 1